module.exports = __webpack_public_path__ + "static/media/wordcount.e1b3aff3.gif";